/**
 * Dates as a shop reads them.
 *
 * <p>A batch is only useful if you can see when it came in - "which of these two
 * did I buy in March" is the question being asked - so the date travels with the
 * batch number everywhere it appears, short enough to fit in a dropdown.
 */
export const shortDate = (value?: string | null): string => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' });
};

/** 24 Sep 26 - the same, with the year always shown. */
export const longDate = (value?: string | null): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

/**
 * 14-10-2026 - day first, as an Indian invoice is read.
 *
 * <p>Taken apart as text rather than put through new Date(). A bill date arrives as
 * "2026-10-14", and Date parses that as midnight UTC: anywhere west of Greenwich it
 * prints the day before. The same trap cost us a payment date once already.
 */
export const invoiceDate = (value?: string | null): string => {
  if (!value) return '';
  const plain = String(value).slice(0, 10);
  const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(plain);
  return parts ? `${parts[3]}-${parts[2]}-${parts[1]}` : String(value);
};
